import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const exigenceEndpoint = `${apiUrl}/smq/Exigence`;

const getResponseData = (response) => {
  const payload = response?.data;

  if (payload?.status === false) {
    throw new Error(payload.message || "Une erreur est survenue");
  }

  return payload;
};

const getErrorMessage = (error) =>
  error?.response?.data?.message ||
  error?.message ||
  "Le service des types d’exigence est indisponible";

const ExigenceService = {
  async getAll() {
    try {
      return getResponseData(await axios.get(exigenceEndpoint));
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  async create(exigence) {
    try {
      return getResponseData(await axios.post(exigenceEndpoint, exigence));
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  async update(exigenceId, exigence) {
    try {
      return getResponseData(
        await axios.put(`${exigenceEndpoint}/${exigenceId}`, exigence)
      );
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  async remove(exigenceId) {
    try {
      return getResponseData(
        await axios.delete(`${exigenceEndpoint}/${exigenceId}`)
      );
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },
};

export default ExigenceService;
